import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuideArticle from "../pages/article/page";
import SeoArticlePage from "../pages/article/ArticlePage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-przewodnik",
    element: <GuideArticle />,
  },
  {
    path: "/artykul/:slug",
    element: <SeoArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;